export enum FuelType {
  PETROL = 1,
  DIESEL = 3,
  ELECTRIC = 6,
  HYBRID = 5
}

